import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "../lib/analytics";

export function usePageviewTracker() {
  const location = useLocation();
  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    // Skip the initial pageview — installAnalytics() already fires one
    if (prevPathRef.current === null) {
      prevPathRef.current = location.pathname;
      return;
    }
    if (location.pathname !== prevPathRef.current) {
      prevPathRef.current = location.pathname;
      trackPageview(location.pathname);
    }
  }, [location.pathname]);
}
